/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Templates_Sync_FailedInputs */

const vi_einvoice_templates_sync_failed = /** @type {(inputs: Einvoice_Templates_Sync_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tải được danh sách mẫu từ MISA. Nhờ quản trị viên kiểm tra kết nối MISA rồi thử lại.`)
};

/**

* @param {Einvoice_Templates_Sync_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_templates_sync_failed = /** @type {((inputs?: Einvoice_Templates_Sync_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Templates_Sync_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_templates_sync_failed(inputs)
});